import styled from 'styled-components';
import { FormControlLabel, Switch as MUISwitch } from '@mui/material';
import { colors } from 'spw-theme';
import { CenteredRow } from 'spw-shared/globalComponents/grid';

export const Switch = styled(MUISwitch)`
  &&.no-pointer .MuiButtonBase-root {
    cursor: default;
  }

  && {
    .MuiButtonBase-root:hover {
      background-color: transparent;
    }
    .MuiTouchRipple-root {
      display: none;
    }

    .MuiSwitch-colorSecondary.Mui-checked {
      padding-right: 0;
    }

    .MuiSwitch-thumb {
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
      height: 16px;
      width: 16px;
      transform: translateY(2px);
    }
  }
`;

export const SwitchLabel = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;

    letter-spacing: 0.25px;
    text-transform: uppercase;

    color: #000000;
    white-space: nowrap;
  }
`;

export const SwitchFormControlLabel = styled(FormControlLabel)`
  && {
    margin-right: 0px;
  }
`;

export const GripperWrapper = styled(CenteredRow)<{ $isBottom?: boolean }>`
  && {
    cursor: ns-resize;
    background-color: ${colors.darkGray};
    height: 16px;
    border-radius: ${({ $isBottom }) =>
      $isBottom ? '0 0 9px 9px' : '9px 9px 0 0'};
  }
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
`;
